<template>
    <div>
        <v-row>
            <div class="mt-2 mb-4 ml-3">
                <v-btn 
                    color="warning" 
                    style="width: 100px" 
                    class="mr-4" 
                    @click="backHandler"> 
                        {{$t('button.back')}}
                </v-btn>
                <!-- check for lock even if its their turn to edit -->
                <v-btn 
                    v-if="DelegatedWFTranDetails && DelegatedWFTranDetails.length > 0 && parentObject.kpi.pmkpiexercisestatus != 'COMPLETED' && parentObject.kpi.pmkpiexercisedstatus != 'LOCKED'"
                    color="primary" 
                    style="width: 100px" 
                    class="mr-4" 
                    @click="addKPIHandler"> 
                      {{$t('button.addnew')}}
                </v-btn>
                <!-- check for lock even if its their turn to edit -->
                <v-btn 
                    v-if="DelegatedWFTranDetails && DelegatedWFTranDetails.length > 0 && parentObject.kpi.pmkpiexercisestatus != 'COMPLETED' && parentObject.kpi.pmkpiexercisedstatus != 'LOCKED'"
                    color="success" 
                    style="width: 100px"
                    @click="submitHandler" 
                > 
                    {{$t('button.submit')}}
                </v-btn>
            </div>
        </v-row>
        <h2 class="mb-3 blue--text">
        {{ this.parentObject.kpi.title }} - 
        <span style="color: #4CAF50;">{{ this.parentObject.kpi.startdate }}</span> 
        <span style="color: grey;"> until </span> 
        <span style="color: #4CAF50;">{{ this.parentObject.kpi.enddate }}</span>
        </h2>


        <v-container fluid style="padding: 0;">
            <v-row>
                <v-col cols="12" md="6">
                    <v-card style="background-color: #1261a0; color:white;">
                        <v-card-title>
                            <h2 class="text-h6"> {{$t('pmreviewexercisesectioncard.commonkpi')}}</h2>
                        </v-card-title>
                        <v-card-text>
                            <v-expansion-panels multiple v-model="expandedPanelsCMMKPI">
                                <v-expansion-panel v-for="kpi in commonKPIList" :key="kpi.id">
                                    <v-expansion-panel-header style="background-color: white; color:#1261a0; display: flex; justify-content: space-between; align-items: center;">
                                    <!-- Goal on the left -->
                                    <div style="flex: 2; text-align: left; white-space: nowrap;">
                                        <strong>{{ kpi.goal }}</strong>
                                    </div>

                                    <!-- Weightage closer to Progress -->
                                    <div style="flex: 1; text-align: center; white-space: nowrap;">
                                        {{$t('pmreviewexercisesectioncard.weightage')}}: <strong>{{ kpi.weightage }}%</strong>
                                    </div>

                                    <!-- Progress on the right -->
                                    <div style="flex: 1; text-align: right; white-space: nowrap;">
                                        {{$t('pmreviewexercisesectioncard.progress')}}: <strong>{{ kpi.progress }}%</strong>
                                    </div>
                                </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                    <!-- <v-expansion-panel-text> -->
                                        <div class="mb-2">
                                            {{$t('pmreviewexercisesectioncard.KPI')}}
                                            <br>
                                            <strong>{{ kpi.kpi }}</strong>
                                        </div>
                                        <div class="mb-2">
                                              {{$t('columns.target')}}
                                            <br>
                                            <strong>{{ kpi.target }}</strong>
                                        </div>
                                        <div v-if="kpi.threshold" class="mb-2">
                                             {{$t('pmreviewexercisesectioncard.threshold')}}
                                            <br>
                                            <strong>{{ kpi.threshold }}</strong>
                                        </div>
                                        <div v-if="kpi.stretch" class="mb-2">
                                             {{$t('pmreviewexercisesectioncard.stretch')}}
                                            <br>
                                            <strong>{{ kpi.stretch }}</strong>
                                        </div>
                                    <!-- </v-expansion-panel-text> -->
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- Second v-card (beside the first one) -->
                <v-col cols="12" md="6">
                    <v-card style="background-color: #1261a0; color:white;">
                        <v-card-title>
                            <h2 class="text-h6">{{$t('pmreviewexercisesectioncard.individualkpi')}}</h2>
                        </v-card-title>
                        <v-card-text>
                            <v-expansion-panels multiple v-model="expandedPanelsINDKPI">
                                <v-expansion-panel v-for="kpi in individualKPIList" :key="kpi.id" :flag="reloadflag">
                                    <v-expansion-panel-header style="background-color: white; color:#1261a0; display: flex; justify-content: space-between; align-items: center;">
                                        <!-- Goal on the left -->
                                        <div style="flex: 2; text-align: left; white-space: normal; word-break: break-word;">
                                            <strong>{{ kpi.goal }}</strong>
                                        </div>

                                        <!-- Weightage closer to Progress -->
                                        <div style="flex: 1; text-align: center; white-space: nowrap;">
                                             {{$t('pmreviewexercisesectioncard.weightage')}}: <strong>{{ kpi.weightage }}%</strong>
                                        </div>

                                        <!-- Progress on the right -->
                                        <div v-if="kpi.progress" style="flex: 1; text-align: right; white-space: nowrap;">
                                             {{$t('pmreviewexercisesectioncard.progress')}}: <strong>{{ kpi.progress }}<span v-if="kpi.basedonpercentage">%</span></strong>
                                        </div>
                                        <div v-else style="flex: 1; text-align: right; white-space: nowrap;">
                                             {{$t('pmreviewexercisesectioncard.progress')}}: <strong>0%</strong>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div class="mb-2">
                                             {{$t('pmreviewexercisesectioncard.KPI')}}
                                            <br>
                                            <strong>{{ kpi.kpi }}</strong>
                                        </div>
                                        <div class="mb-2">
                                             {{$t('columns.target')}}
                                            <br>
                                            <strong>{{ kpi.target }}</strong>
                                        </div>
                                        <div v-if="kpi.threshold" class="mb-2">
                                             {{$t('pmreviewexercisesectioncard.threshold')}}
                                            <br>
                                            <strong>{{ kpi.threshold }}</strong>
                                        </div>
                                        <div v-if="kpi.stretch" class="mb-2">
                                             {{$t('pmreviewexercisesectioncard.stretch')}}
                                            <br>
                                            <strong>{{ kpi.stretch }}</strong>
                                        </div>
                                        <div style="text-align: right;">
                                            <v-btn v-if="DelegatedWFTranDetails && DelegatedWFTranDetails.length > 0 && parentObject.kpi.pmkpiexercisestatus != 'COMPLETED' && parentObject.kpi.pmkpiexercisedstatus != 'LOCKED'" color="primary" class="mr-2" @click="editKPIHandler(kpi)">
                                                 {{$t('pmselfservice.editdetails')}}
                                            </v-btn>
                                            <v-btn color="primary" @click="goToProgress(kpi)">
                                                {{$t('pmreviewexercisesectioncard.progress')}}
                                            </v-btn>
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="KPIdialog" max-width="900px">
          <v-card>
            <v-card-text>
              <v-container>
                    <v-row>
                        <span v-if="isEdit" style="font-weight: bold;" class="mb-2 mt-6">{{$t('performancemanagement.editkpi')}}</span>
                        <span v-else style="font-weight: bold;" class="mb-2 mt-6">{{$t('performancemanagement.createnewkpi')}}</span>
                    </v-row>

                    <div>
                        <v-row class="pb-n4 mb-4 mt-0">
                            <v-col v-if="!isEdit" cols="9" class="ml-0 pl-0">
                                <v-radio-group class="mt-2" v-model="radioSelected" row>
                                    <v-radio
                                        :value="1"
                                    >
                                        <template v-slot:label>
                                            <span class="radio-label">{{$t('pmselfservice.individual')}}</span>
                                        </template>
                                    </v-radio>
                                    <!-- <v-radio
                                        :value="2"
                                    >
                                        <template v-slot:label>
                                            <span class="radio-label">{{$t('pmreviewexercisesectioncard.commonkpi')}}</span>
                                        </template>
                                    </v-radio> -->
                                </v-radio-group>
                            </v-col>

                            <v-col v-if="radioSelected === 1" cols="3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.weightage')"
                                    type="number"
                                    :rules="[rules.required]"
                                    v-model="formData.weightage"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-col>

                            <v-col v-else cols="3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.weightage')"
                                    type="number"
                                    :rules="[rules.required]"
                                    v-model="formData.weightage"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <div v-if="radioSelected === 1" class="mr-3">
                            <v-row v-if="!isEdit && KPICategoryList.length > 0" class="pb-n4 mt-n7">
                                <v-autocomplete
                                    outlined
                                    :label="$t('pmkpiitem.kpicategory')"
                                    type="text"
                                    ref="pmkpicatid"
                                    v-model="pmkpicatid"
                                    dense
                                    :items="KPICategoryList"
                                    @change="changeKPICat(pmkpicatid)"
                                    clearable
                                ></v-autocomplete>
                            </v-row>
                            <v-row v-if="kpicatselection && !isEdit" class="pb-n4 mt-n3">
                                <v-autocomplete
                                    outlined
                                    :label="$t('performancemanagement.selectkpi')"
                                    type="text"
                                    ref="kpiitemid"
                                    :rules="[rules.required]"
                                    v-model="formData.kpiitemid"
                                    dense
                                    :items="KPIItemSelectionList"
                                    @change="changeKPIItem(formData.kpiitemid)"
                                ></v-autocomplete>
                            </v-row>
                            <v-row class="pb-n4 mt-n3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.goal')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="formData.goal"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.KPI')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="formData.kpi"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n6">
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('performancemanagement.targetoption')"
                                        type="text"
                                        ref="pmtargetoptionid"
                                        v-model="formData.pmtargetoptionid"
                                        dense
                                        :items="targetOptionList"
                                        @change="changeTargetOption(formData.pmtargetoptionid)"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                        type="text"
                                        ref="pmcalmethodid"
                                        v-model="formData.pmcalmethodid"
                                        dense
                                        :items="calculationMethodList"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmkpiitem.kpifinalscorecalmethod')"
                                        type="text"
                                        ref="pmkpifinalscorecalmethodid"
                                        v-model="formData.pmkpifinalscorecalmethodid"
                                        dense
                                        :items="KPIFinalScoreList"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row class="pb-n4 mt-n8">
                                <v-col cols="12" class="mx-0">
                                    <v-row>
                                        <!-- <v-col v-if="formData.targetType == 'Target, threshold, stretch'" cols="3" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.threshold')"
                                                type="number"
                                                v-model="formData.threshold"
                                                ref="threshold"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col> -->
                                        <v-col cols="3" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('columns.target')"
                                                type="number"
                                                v-model="formData.target"
                                                ref="target"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                        <!-- <v-col v-if="formData.targetType == 'Target, threshold, stretch'" cols="3" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.stretch')"
                                                type="number"
                                                v-model="formData.stretch"
                                                ref="stretch"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col> -->
                                        <v-col cols="3" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmkpiset.subperiodcount')"
                                                type="number"
                                                v-model="formData.subperiodcount"
                                                ref="subperiodcount"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>

                        <div v-else class="mr-3">
                            <v-row class="pb-n4 mt-n7">
                                <v-autocomplete
                                    outlined
                                    :label="$t('performancemanagement.selectkpi')"
                                    type="text"
                                    ref="cmmkpiid"
                                    :rules="[rules.required]"
                                    v-model="formData.cmmkpiid"
                                    dense
                                    :items="commonKPISelectionList"
                                    @change="changeCommonKPI(formData.cmmkpiid)"
                                ></v-autocomplete>
                            </v-row>
                            <v-row class="pb-n4 mt-n3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.goal')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="formData.goal"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n3">
                                <v-text-field
                                    outlined
                                   :label="$t('pmreviewexercisesectioncard.KPI')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="formData.kpi"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n6">
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('performancemanagement.targetoption')"
                                        type="text"
                                        ref="pmtargetoptionid"
                                        :rules="[rules.required]"
                                        v-model="formData.pmtargetoptionid"
                                        dense
                                        :items="targetOptionList"
                                        @change="changeTargetOption(formData.pmtargetoptionid)"
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                        type="text"
                                        ref="pmcalmethodid"
                                        :rules="[rules.required]"
                                        v-model="formData.pmcalmethodid"
                                        dense
                                        :items="calculationMethodList"
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row class="pb-n4 mt-n8">
                                <v-col cols="6" class="mx-0">
                                    <v-row>
                                        <v-col v-if="formData.targetType == 'Target, threshold, stretch'" cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.threshold')"
                                                type="text"
                                                :rules="[rules.required]"
                                                v-model="formData.threshold"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('columns.target')"
                                                type="text"
                                                :rules="[rules.required]"
                                                v-model="formData.target"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-if="formData.targetType == 'Target, threshold, stretch'" cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.stretch')"
                                                type="text"
                                                :rules="[rules.required]"
                                                v-model="formData.stretch"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="isEdit" color="yellow darken-1" text @click="deleteHandler">{{$t('button.delete')}}</v-btn>
              <v-btn color="green darken-1" text @click="saveHandler">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeHandler">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showConfirmDialog" max-width="400">
        <v-card>
            <v-card-title class="text-h6">Confirm Action</v-card-title>
            <v-card-text>
            Do you want to <strong class="success--text">APPROVE</strong> or <strong class="error--text">SEND BACK</strong> KPI to previous reviewer?
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" text @click="showConfirmDialog = false">Cancel</v-btn>
            <v-btn color="error" text @click="showConfirmDialog = false; sendBackAction()">Send Back</v-btn>
            <v-btn color="success" text @click="showConfirmDialog = false; approveAction()">Approve</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <v-dialog v-model="showHandleWorkflowDialog" max-width="600">
        <v-card>
            <v-card-title class="text-h6">Ooops...</v-card-title>
            <v-card-text class="text-body-1" style="font-size: 1.1rem; line-height: 1.6; color: #000;">
            It seems that you do not have a role assignment for next level reviewer.<br> Do you want to <strong class="success--text">SUBMIT TO NEXT PERSON</strong> or <strong class="error--text">END WORKFLOW</strong>?
            </v-card-text>
            <v-card-actions class="py-4" style="font-size: 1.15rem;">
            <v-spacer></v-spacer>
            <v-btn color="warning" text style="font-size: 1.05em;" @click="showHandleWorkflowDialog = false">Cancel</v-btn>
            <v-btn color="error" text style="font-size: 1.05em;" @click="showHandleWorkflowDialog = false; endWorkflow()">End Workflow</v-btn>
            <v-btn color="success" text style="font-size: 1.05em;" @click="showHandleWorkflowDialog = false; addAndsubmitToNextPerson()">Submit to Next Person</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <v-dialog v-model="addAndSendToNextReviewerDialog" max-width="900px">
          <v-card>
            <v-card-text>
                <v-container>
                    <v-row class="ml-n6">
                        <v-col cols="12">
                            <span style="font-weight: bold;">
                            {{ $t('pmselfservice.sendtonextreviewer') }} &nbsp;
                            </span>
                        </v-col>
                    </v-row>
                    <div>
                        <v-row class="pb-n4 mb-n4 mt-2">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.name')"
                                type="text"
                                v-model="nextReviewer.staffid"
                                dense
                                :items="staffList"
                                @input="updateValue"
                                @change="changeStaff(nextReviewer.staffid)"
                            ></v-autocomplete>
                        </v-row>

                        <v-row class="mt-n8 mb-n16">
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.staffno')"
                                    type="text"
                                    v-model="nextReviewer.staffcode"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.company')"
                                    type="text"
                                    v-model="nextReviewer.staffcompany"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="addAndSendToNextReviewer">{{$t('button.send')}}</v-btn>
              <v-btn color="red darken-1" text @click="addAndSendToNextReviewerDialog = false">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
        <div v-if="isSuccess">
        <app-success
            v-bind:parentObject="{
                messageSuccess: this.successMsg,
                isSuccess: this.isSuccess,
            }"
            @close-success="goBackToMyTask"
        />
        </div>
    </div>
</template>

<script>

import ErrorDialog from "../../components/common/ErrorDialog";
import SuccessDialog from "@/components/common/SuccessDialog";
import moment from "moment";

export default {

    props: {
        parentObject: Object,
    },

    components: {
        "app-error": ErrorDialog,
        "app-success": SuccessDialog,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            KPIdialog: false,
            radioSelected: 1,

            formData: {
                indkpiid: null,
                kpiexerdid: this.parentObject.kpi.kpiexercisedid,
                pmtargetoptionid: null,
                pmcalmethodid: null,
                weightage: null,
                goal: null,
                kpi: null,
                target: null,
                threshold: null,
                stretch: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                staffid : this.$store.getters.staffId,
                targetType: null,
                progress: 0,
                cmmkpiid: null,
                kpiitemid: null,
                subperiodcount: 1, // default value
                pmkpifinalscorecalmethodid: null, // for KPI Final Score Calculation Method
            },

            reloadflag:0,
            kpi: [],
            commonKPIList: [],
            individualKPIList: [],
            targetOptionFull: [],
            targetOptionList: [],
            calculationMethodList: [],
            commonKPISelectionList: [],
            commonKPIFull: [],

            KPIItemSelectionList: this.parentObject.KPIItemSelectionList || [],
            KPIItemFull: this.parentObject.KPIItemFull || [],
            KPICategoryList: this.parentObject.KPICategoryList || [],
            pmkpicatid: null, // for KPI Category
            kpicatselection: false, // for KPI Category selection
            KPIFinalScoreList: [],
            DelegatedWFTranDetails: [],
            showConfirmDialog: false,

            workflowRoles: [],
            showHandleWorkflowDialog: false,
            addAndSendToNextReviewerDialog: false,
            nextReviewer: {
                staffid: null,
                staffcode: '',
                staffcompany: '',
            },
            staffList: [],
            staffFull: [],

            isErr: false,
            errMsg: '',
            isEdit: false,
            isSuccess: false,
            successMsg: '',
            expandedPanelsINDKPI: [],
            expandedPanelsCMMKPI: []
        };
    },

    watch: {
        radioSelected() {
            this.resetSelections();
        },

        individualKPIList(newList) {
            this.expandedPanelsINDKPI = newList.map((_, i) => i);
        },

        commonKPIList(newList) {
            this.expandedPanelsCMMKPI = newList.map((_, i) => i);
        }
    },

    methods: {
        goBackToMyTask() {
            this.isSuccess = false;
            this.$router.push({ name: "selfservicemytask" });
        },

        goToProgress(kpi){
            this.$router.push({ name: 'selfservicekpiprogress', params: { kpi: kpi, pmkpiexercisestatus: this.parentObject.kpi.pmkpiexercisestatus } });
        },

        backHandler(){
            this.$router.push({ name: 'selfserviceperformance' });
        },

        addKPIHandler() {
            this.isEdit = false;
            this.resetSelections();
            this.radioSelected = 1;
            this.KPIdialog = true;
        },

        editKPIHandler(kpi){
            this.radioSelected = 1;
            this.isEdit = true;
            this.formData = { ...this.formData, ...kpi};
            this.formData.indkpiid = kpi.id;
            console.log("EDITKPIDATA", this.formData);
            this.KPIdialog = true;
            this.changeTargetOption(this.formData.pmtargetoptionid);//this is use to hide/show the threshold and stretch column in the dialog 
        },

        submitHandler(){
            if (this.DelegatedWFTranDetails[0].sequenceno === 0) {
                // Directly approve without dialog
                this.approveAction();
            } else {
                this.showConfirmDialog = true;
            }
        },

        approveAction(){
            console.log("Approve Action");
            const vm = this;

            const workflowRoles = vm.workflowRoles.length;
            const totalLevel = vm.DelegatedWFTranDetails[0].totallevel;
            const currentLevelNo = vm.DelegatedWFTranDetails[0].lvlno;

             // Not enough role assignments 
            const isMissingRole = workflowRoles !== totalLevel;

            // "Before missing level" means current level equals workflowRoles
            const isLevelBeforeMissing = currentLevelNo === workflowRoles;

            console.log("workflowRoles", workflowRoles);
            console.log("totalLevel", totalLevel);
            console.log("currentLevelNo", currentLevelNo);  
            console.log("isMissingRole", isMissingRole);
            console.log("isLevelBeforeMissing", isLevelBeforeMissing);

            // If not enough role assignments AND is level before missing and have wfsetupdid, handle workflow
            if (isMissingRole && isLevelBeforeMissing && this.parentObject.kpi.wfsetupdid) {
                console.log("Don't have enough role assignments");
                this.showHandleWorkflowDialog = true;
            }else{
                const selectedData = {
                kpiexerdid: this.formData.kpiexerdid,
                staffid: this.formData.staffid,
                kpiexerid: this.parentObject.kpi.kpiexerciseid,
            };
            console.log("Selected Data", selectedData);

            this.$store.dispatch('post', {url: "/ss/kpi/submit", payload: selectedData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    // vm.errMsg = res.data.error;
                    vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                } else {
                    //Success
                    //Send to MyTask page with update MyTask list
                    console.log("SUCCESS");
                    vm.successMsg = "Target Setting submitted successfully.";
                    vm.isSuccess = true;
                    this.goBackToMyTask();

                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
            }
        },

        sendBackAction() {
            // For now do nothing
            console.log("SEND BACK chosen - no action yet");

            //Send kpiexercisedid and sequenceno

            const selectedData = {
                recordid: this.formData.kpiexerdid,
                sequenceno: this.DelegatedWFTranDetails[0].sequenceno,
                currentStaffID: this.formData.staffid
            };

            console.log("Selected Data", selectedData);
            const vm = this;

            this.$store.dispatch('post', {url: "/ss/kpi/submit/sendback", payload: selectedData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    // vm.errMsg = res.data.error;
                    vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                } else {
                    //Success
                    //Send to MyTask page with update MyTask list
                    console.log("SUCCESS");
                    vm.successMsg = "Target Setting submitted successfully.";
                    vm.isSuccess = true;
                    this.goBackToMyTask();

                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        addAndsubmitToNextPerson(){
            console.log("Submitting to Next Person");
            this.addAndSendToNextReviewerDialog = true;
        },

        addAndSendToNextReviewer(){
            console.log("Sending to Next Reviewer");
            const vm = this;

            const nextLvlno = vm.DelegatedWFTranDetails[0].lvlno + 1;
            const nextSequenceno = vm.DelegatedWFTranDetails[0].sequenceno + 1;

            const selectedData = {
                pmkpiexercisedid: this.formData.kpiexerdid,
                nextApproverID: this.nextReviewer.staffid,
                currentStaffID: this.$store.getters.staffId,
                nextLvlno: nextLvlno,
                wftranid: this.DelegatedWFTranDetails[0].wftranid,
                wftrandid: this.DelegatedWFTranDetails[0].id,
                nextSequenceno: nextSequenceno,
            };

            console.log("Selected Data", selectedData);

            this.$store.dispatch('put', {url: "/ss/kpi/addandsubmit", payload: selectedData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    // vm.errMsg = res.data.error;
                    vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                } else {
                    vm.successMsg = "Target Setting submitted to next reviewer successfully.";
                    vm.isSuccess = true;
                    this.goBackToMyTask();
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        endWorkflow(){
            console.log("Ending Workflow");
            const vm = this;
            const selectedData = {
                pmkpiexercisedid: this.formData.kpiexerdid,
                staffid: this.$store.getters.staffId,
                wftrandid: this.DelegatedWFTranDetails[0].id,
                wftranid: this.DelegatedWFTranDetails[0].wftranid,
            };

            this.$store.dispatch('put', {url: "/ss/kpi/endworkflow", payload: selectedData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    // vm.errMsg = res.data.error;
                    vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                } else {
                    vm.successMsg = "Workflow ended successfully.";
                    vm.isSuccess = true;
                    this.goBackToMyTask();
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        loadTargetOptionListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/kpitargetoption/all' })
            .then((res) => {

                vm.targetOptionFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.targetOptionList.push({
                        text: res.data.rec[i].targetoption,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        changeTargetOption(id) {
            let item = this.targetOptionFull.find((item) => item.id === id);
            this.formData.targetType = item.targetoption;
        },

        loadCalculationMethodListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpicalculationmethod/all' })
            .then((res) => {
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.calculationMethodList.push({
                        text: res.data.rec[i].calmethod,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        // saveHandler() {
        //     const vm = this;

        //     // if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        //     //     return false;
        //     // } //not checking for permission because if need to check have to assign to all staff, to many work to do

        //     if(vm.radioSelected == 1){ //Individual KPI
        //         if(!vm.isEdit){
        //             this.$store.dispatch('post', {url: "/kpiindividual/create", payload: vm.formData})
        //             .then((res) => {
        //                 if (res.data.error) {
        //                     vm.isErr = true;
        //                     // vm.errMsg = res.data.error;
        //                     vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
        //                 } else {
        //                     await vm.addProgressReview(res.data.result.id);
        //                     //Add to array individualKPIList
        //                     vm.individualKPIList.push({ ...vm.formData });
        //                     this.closeHandler();
        //                 }
        //             })
        //             .catch((err) => {
        //                 vm.isErr = true;
        //                 vm.errMsg = err.message || err;
        //             });
        //         }else{
        //             this.$store.dispatch('put', {url: "/kpiindividual/" + vm.formData.indkpiid, payload: vm.formData})
        //             .then((res) => {
        //                 if (res.data.error) {
        //                     vm.isErr = true;
        //                     // vm.errMsg = res.data.error;
        //                     vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
        //                 } else {
        //                     //Update array individualKPIList
        //                     let index = vm.individualKPIList.findIndex((item) => item.id === vm.formData.id);
        //                     vm.individualKPIList[index] = { ...vm.formData };
        //                     this.closeHandler();
        //                 }
        //             })
        //             .catch((err) => {
        //                 vm.isErr = true;
        //                 vm.errMsg = err.message || err;
        //             });
        //         }
        //     }else if(vm.radioSelected ==2){ //Common KPI
        //         this.$store.dispatch('post', {url: "/kpiindividual/common/create", payload: vm.formData})
        //         .then((res) => {
        //             if (res.data.error) {
        //                 vm.isErr = true;
        //                 // vm.errMsg = res.data.error;
        //                 vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
        //             } else {
        //                 const newCommonKPI = {
        //                     ...vm.formData, // Copy all properties from formData
        //                     id: vm.formData.cmmkpiid, // Override the id with cmmkpiid
        //                 };

        //                 vm.commonKPIList.push(newCommonKPI); 
        //                 this.closeHandler();
        //             }
        //         })
        //         .catch((err) => {
        //             vm.isErr = true;
        //             vm.errMsg = err.message || err;
        //         });
        //     }

        // },

        async saveHandler() {
            const vm = this;

            try {
                if (vm.radioSelected === 1) { // Individual KPI
                    if (!vm.isEdit) {
                        const res = await this.$store.dispatch('post', {
                            url: "/kpiindividual/create",
                            payload: vm.formData
                        });

                        if (res.data.error) {
                            vm.isErr = true;
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            return;
                        }

                        await vm.addProgressReview(res.data.result.id);
                        //Add to array individualKPIList
                        vm.individualKPIList.push({ ...vm.formData, id: res.data.result.id, progress: 0 });
                        this.closeHandler();

                    } else {
                        const res = await this.$store.dispatch('put', {
                            url: "/kpiindividual/" + vm.formData.indkpiid,
                            payload: vm.formData
                        });

                        if (res.data.error) {
                            vm.isErr = true;
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            return;
                        }

                        //Update array individualKPIList
                        let index = vm.individualKPIList.findIndex((item) => item.id === vm.formData.id);
                        vm.individualKPIList[index] = { ...vm.formData };
                        this.closeHandler();
                    }
                } else if (vm.radioSelected === 2) { // Common KPI
                    const res = await this.$store.dispatch('post', {
                        url: "/kpiindividual/common/create",
                        payload: vm.formData
                    });

                    if (res.data.error) {
                        vm.isErr = true;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        return;
                    }

                    const newCommonKPI = {
                        ...vm.formData,
                        id: vm.formData.cmmkpiid, // Set correct ID
                    };

                    vm.commonKPIList.push(newCommonKPI);
                    this.closeHandler();
                }
            } catch (err) {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            }
        },


        async addProgressReview(id){
            console.log("addProgressReview");
            // id - Individual KPI id
            // startdate and enddate - to use to estimate/get the dates in between the subperiod counts 

            // Based on the subperiodcount, I want to get review date(s)
            // Example: subperiodcount = 4, startdate = 2023-01-01, enddate = 2023-12-31
            // I want to generate 4 review dates in between the startdate and enddate
            // Get the appropriate dates based on the subperiodcount

            const vm = this;

            const results = [];
            const start = moment(vm.parentObject.kpi.startdate, "DD-MM-YYYY");
            const end = moment(vm.parentObject.kpi.enddate, "DD-MM-YYYY");

            const subperiodcount = vm.formData.subperiodcount || 1; // Default to 1 if not set
            const intervalDays = end.diff(start, 'day') / subperiodcount;

            for (let i = 1; i <= subperiodcount; i++) {
                const reviewDate = start.clone().add(intervalDays * i, 'days').format('YYYY-MM-DD');
                results.push({
                individualkpiid: id,
                reviewdate: reviewDate
                });
            }

            try {
                const res = await this.$store.dispatch('post', { url: "/kpiexercise/generate/indkpiprg/" + vm.formData.userid , payload: results });

                if (res.status === 201) {
                    console.log("RESINDKPIPRG", res);
                } else {
                    vm.isErr = true;
                }
            } catch (err) {
                console.error('Error in addProgressReview:', err);
                vm.isErr = true;
                vm.errMsg = err;
            }
        },

        deleteHandler() {
            const vm = this;

            // if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
            //     return false;
            // }//not checking for permission, same reason as the saveHanlder()

            if (confirm(this.$t('performancemanagement.deleteindividualkpi', { code: this.formData.goal }))) {
                this.$store
                .dispatch('delete', { url: "/kpiindividual/indkpi/" + this.formData.id })
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                        this.resetSelections();
                        this.KPIdialog = false;
                    } else {
                        this.KPIdialog = false;
                        this.reloadIndividualKPIList();//after all thing completed, reload the individual kpi list
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            }
        },

        reloadIndividualKPIList(){
            this.loadIndividualKPIList();
            this.reloadflag++;
        },

        // async loadKPIItemHandler() {
        //     const vm = this;
        //     const categoryIdSet = new Set(); // For checking duplicates

        //     return this.$store.dispatch('get', { url: '/kpiitem/individual/staff/' + vm.formData.kpiexerdid })
        //     .then((res) => {
        //         vm.KPIItemFull = res.data.rec;
        //         console.log("KPIItemFull", vm.KPIItemFull);
        //         for (let i = 0; i < res.data.rec.length; i++) {
        //             vm.KPIItemSelectionList.push({
        //                 text: res.data.rec[i].goal + " - " + res.data.rec[i].kpi,
        //                 goal: res.data.rec[i].goal,
        //                 kpi : res.data.rec[i].kpi,
        //                 pmtargetoptionid: res.data.rec[i].pmtargetoptionid,
        //                 pmcalmethodid: res.data.rec[i].pmcalmethodid,
        //                 target: res.data.rec[i].target,
        //                 threshold: res.data.rec[i].threshold,
        //                 stretch: res.data.rec[i].stretch,
        //                 weightage: res.data.rec[i].weightage,
        //                 value: res.data.rec[i].id,
        //             });

        //             // Extract unique KPI categories
        //             if (!categoryIdSet.has(res.data.rec[i].pmkpicatid)) {
        //                 categoryIdSet.add(res.data.rec[i].pmkpicatid);
        //                 vm.KPICategoryList.push({
        //                     id: res.data.rec[i].pmkpicatid,
        //                     name: res.data.rec[i].pmkpicatname,
        //                     code: res.data.rec[i].pmkpicatcode,
        //                     value: res.data.rec[i].pmkpicatid,
        //                     text: res.data.rec[i].pmkpicatcode + " - " + res.data.rec[i].pmkpicatname
        //                 });
        //             }
        //         }

        //         console.log("KPI Category List", vm.KPICategoryList);
        //         console.log("KPIItemSelectionList", vm.KPIItemSelectionList);
        //     })
        //     .catch((err) => {
        //         vm.isErr = true;
        //         vm.errMsg = err;
        //         vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        //     });
        // },

        loadStaffCommonKPIHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpiindividual/commonselect/' + vm.formData.kpiexerdid })
            .then((res) => {
                vm.commonKPIFull = res.data.rec;
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.commonKPISelectionList.push({
                        text: res.data.rec[i].description,
                        goal: res.data.rec[i].goal,
                        kpi : res.data.rec[i].kpi,
                        pmtargetoptionid: res.data.rec[i].pmtargetoptionid,
                        pmcalmethodid: res.data.rec[i].pmcalmethodid,
                        target: res.data.rec[i].target,
                        threshold: res.data.rec[i].threshold,
                        stretch: res.data.rec[i].stretch,
                        weightage: res.data.rec[i].weightage,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        changeCommonKPI(id){
            let item = this.commonKPIFull.find((item) => item.id === id);
            this.formData.goal = item.goal;
            this.formData.kpi = item.kpi;
            this.formData.pmtargetoptionid = item.pmtargetoptionid;
            this.changeTargetOption(item.pmtargetoptionid);
            this.formData.pmcalmethodid = item.pmcalmethodid;
            this.formData.target = item.target;
            this.formData.threshold = item.threshold;
            this.formData.stretch = item.stretch;
            this.formData.weightage = item.weightage;
        },

        changeKPIItem(id){
            let item = this.KPIItemFull.find((item) => item.id === id);
            this.formData.goal = item.goal;
            this.formData.kpi = item.kpi;
            this.formData.pmtargetoptionid = item.pmtargetoptionid;
            this.changeTargetOption(item.pmtargetoptionid);
            this.formData.pmcalmethodid = item.pmcalmethodid;
            this.formData.target = item.target;
            this.formData.threshold = item.threshold;
            this.formData.stretch = item.stretch;
            this.formData.weightage = item.weightage;
            this.formData.subperiodcount = item.subperiodcount || 1; // Default to 1 if not set
            this.formData.pmkpifinalscorecalmethodid = item.pmkpifinalscorecalmethodid; // For KPI Final Score Calculation Method
        },

        changeKPICat(id){

            if (!id || id === null || id === "") {
                this.kpicatselection = false;
                this.KPIItemSelectionList = [];
                return;
            }

            // Filter KPI items by selected category id
            this.KPIItemSelectionList = this.KPIItemFull
            .filter(item => item.pmkpicatid === id)
            .map(item => ({
                text: item.goal + " - " + item.kpi,
                goal: item.goal,
                kpi: item.kpi,
                pmtargetoptionid: item.pmtargetoptionid,
                pmcalmethodid: item.pmcalmethodid,
                target: item.target,
                threshold: item.threshold,
                stretch: item.stretch,
                weightage: item.weightage,
                value: item.id,
            }));

            this.kpicatselection = true;
        },

        loadCommonKPIList(){
            console.log("commonKPI ParentObject", this.parentObject.kpi); 
            const vm = this;
            //change to store getter staffid when finish setup
            this.$store.dispatch('get', {url: "/kpiindividual/sscommon/" + this.parentObject.kpi.kpiexercisedid})
            .then(function (res) {
                vm.commonKPIList = res.data.rec;
                console.log("commonKPIList: ", vm.commonKPIList);
                })
            .catch(function (err) {
                vm.errMsg = err;
            });

        },

        loadIndividualKPIList(){
            const vm = this;
            //change to store getter staffid when finish setup
            this.$store.dispatch('get', {url: "/kpiindividual/" + this.parentObject.kpi.kpiexercisedid})
            .then(function (res) {
                vm.individualKPIList = res.data.rec;
                console.log("individualKPIList: ", vm.individualKPIList);
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        closeHandler() {
            this.radioSelected = 1;
            this.KPIdialog = false;
            this.isErr = false;
            this.isEdit= false;
            this.resetSelections();
        },


        resetSelections() {
            // Find default Target option
            const targetOption = this.targetOptionList.find(opt => opt.text === "Target only");

            //Find default Calculation Method - Achievement/Target
            const calMethod = this.calculationMethodList.find(opt => opt.text === "Achievement / Target");

            //Find default KPI Final Score Calculation Method - Take Last
            const kpiFinalScoreMethod = this.KPIFinalScoreList.find(opt => opt.text === "Take Last");

            this.formData = {
                indkpiid: null,
                kpiexerdid: this.parentObject.kpi.kpiexercisedid,
                pmtargetoptionid: targetOption ? targetOption.value : null,
                pmcalmethodid: calMethod ? calMethod.value : null,
                weightage: null,
                goal: null,
                kpi: null,
                target: null,
                threshold: null,
                stretch: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                targetType: null,
                cmmkpiid: null,
                kpiitemid: null,
                subperiodcount: 1, // default value
                pmkpifinalscorecalmethodid: kpiFinalScoreMethod ? kpiFinalScoreMethod.value : null, // for KPI Final Score Calculation Method
            };
        },

        loadKPIFinalScoreListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpifinalscorecalmethod/all' })
            .then((res) => {
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.KPIFinalScoreList.push({
                        text: res.data.rec[i].description,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        loadDelegatedWFTranDetails() {
            const vm = this;
            this.$store.dispatch('get', { url: '/ss/delegated/wftrand/' + this.formData.kpiexerdid + "/" + this.formData.staffid })
                .then((res) => {
                    vm.DelegatedWFTranDetails = res.data.rec;
                    console.log("DelegatedWFTranDetails: ", vm.DelegatedWFTranDetails);
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        loadWorkflowRoles() {
            const vm = this;
            this.$store.dispatch('get', { url: '/ss/kpi/workflow/roles/' + this.formData.kpiexerdid + '/' + this.formData.staffid})
                .then((res) => {
                    vm.workflowRoles = res.data.rec;
                    console.log("Workflow Roles: ", vm.workflowRoles);
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        loadStaffList(){
            const vm = this;
            const today = new Date();

            this.$store.dispatch('get', {url: "/staff/all/" + this.$store.getters.userId})
            .then((res) => {

                const staffRecords = res.data.rec;

                // Filter staff records where cessadate > today's date
                const filteredStaff = staffRecords.filter(staff => {
                    const cessadate = new Date(staff.cessadate);
                    return cessadate > today;
                });

                vm.staffFull = filteredStaff;

                // Populate staffList with the filtered data
                vm.staffList = filteredStaff.map(staff => ({
                    text: staff.psndetails,
                    value: staff.id,
                }));
                
            }).catch((err) => {
                console.error(err)
            });
        },

        changeStaff(id) {
            let item = this.staffFull.find((item) => item.id === id);
            this.nextReviewer.staffcode = item?.staffcode ?? null;
            this.nextReviewer.staffcompany = item?.compnycode ?? null;
        },

    },

    mounted() {
        this.loadCommonKPIList();
        this.loadIndividualKPIList();
        this.loadTargetOptionListHandler();
        this.loadCalculationMethodListHandler();
        this.loadKPIFinalScoreListHandler();
        this.loadDelegatedWFTranDetails();
        this.loadWorkflowRoles();
        this.loadStaffList();
    },

};

</script>

<style>
.v-expansion-panel-header .v-icon.mdi-chevron-down.theme--light {
    color: #1261a0 !important;
}</style>

<style scoped>

</style>